(function () {
  function initCalculator(root) {
    if (!root || root.dataset.hbInit === "1") return;

    const slider = root.querySelector("[data-weight-slider]");
    const weightValue = root.querySelector("[data-weight-value]");
    const resultContainer = root.querySelector("[data-result-container]");
    const toggleButtons = root.querySelectorAll(".hb-feeding-calc__toggle-btn");
    const resultTemplate =
      root.getAttribute("data-result-template") || "We recommend {x} bags per month";

    if (!slider || !weightValue || !resultContainer) return;

    root.dataset.hbInit = "1";

    const feedingChart = [
      { weight: 0, bags: 1 },
      { weight: 5, bags: 2 },
      { weight: 10, bags: 3 },
      { weight: 20, bags: 4 },
      { weight: 30, bags: 5 },
      { weight: 40, bags: 7 },
      { weight: 50, bags: 9 },
      { weight: 60, bags: 10 },
      { weight: 70, bags: 12 },
      { weight: 80, bags: 13 },
      { weight: 90, bags: 14 },
      { weight: 100, bags: 15 },
    ];

    let currentMode = "boosting";

    function setSliderProgress() {
      const value = Number(slider.value);
      const min = Number(slider.min || 0);
      const max = Number(slider.max || 100);
      const pct = max === min ? 0 : ((value - min) / (max - min)) * 100;
      slider.style.setProperty("--slider-progress", pct + "%");
    }

    function interpolateBags(weight) {
      if (weight <= feedingChart[0].weight) return feedingChart[0].bags;
      if (weight >= feedingChart[feedingChart.length - 1].weight)
        return feedingChart[feedingChart.length - 1].bags;

      for (let i = 0; i < feedingChart.length - 1; i++) {
        const a = feedingChart[i];
        const b = feedingChart[i + 1];
        if (weight >= a.weight && weight <= b.weight) {
          const ratio = (weight - a.weight) / (b.weight - a.weight);
          return a.bags + ratio * (b.bags - a.bags);
        }
      }
      return feedingChart[feedingChart.length - 1].bags;
    }

    function render() {
      const weight = Number(slider.value);
      weightValue.textContent = weight;

      let bags = interpolateBags(weight);
      if (currentMode === "boosting") bags *= 0.25;

      const rounded = Math.ceil(bags);
      resultContainer.innerHTML = resultTemplate.replace(
        "{x}",
        '<span class="hb-feeding-calc__result-number">' + rounded + "</span>"
      );

      setSliderProgress();
    }

    slider.addEventListener("input", render, { passive: true });
    slider.addEventListener("change", render, { passive: true });

    toggleButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        toggleButtons.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        currentMode = btn.getAttribute("data-mode") || "full";
        render();
      });
    });

    render();
  }

  function initAll() {
    document.querySelectorAll(".hb-feeding-calc").forEach(initCalculator);
  }

  // Run once on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify editor + dynamic section loads
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:select", initAll);

  // Catch late-injected HTML (page content, apps, etc.)
  const obs = new MutationObserver(() => initAll());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
